import { render, staticRenderFns } from "./DataMessageView.vue?vue&type=template&id=1682d268&scoped=true&"
import script from "./DataMessageView.vue?vue&type=script&lang=js&"
export * from "./DataMessageView.vue?vue&type=script&lang=js&"
import style0 from "./DataMessageView.vue?vue&type=style&index=0&id=1682d268&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1682d268",
  null
  
)

export default component.exports